// © Microsoft Corporation. All rights reserved.

import { IActionPayload, IDataConnector } from "@msnews/experiences-redux-contracts";

import { PageBase } from "@msnews/experiences-page-base";

/**
 * Helper function to create an action payload
 * @param connector The connector (if applicable) where the action will be dispatched
 * @param type The Action Type (name of the action)
 * @param args Arguments to be passed to the action
 * @param experienceInstanceId If defined, the id of an experience instance, that will be used by action receiver
 */
export function getActionPayload(connector: IDataConnector<any, any>, type: string, args: any[], experienceInstanceId: string): IActionPayload {
    let stateKey: string = undefined;
    if (connector) {
        if (!connector.parentNamespace) {
            stateKey = connector.namespace;
        } else {
            stateKey = connector.parentNamespace + "." + connector.namespace;
        }
    }

    return {
        key: stateKey,
        experienceInstanceId: experienceInstanceId,
        type: type,
        params: args
    };
}

/**
 * Helper function to dispatch an action either to a connector's namespaced store, or to the root store for the entire app.
 * @param connector The connector (if applicable) where the action will be dispatched
 * @param payload The action payload
 */
export function dispatchAction(connector: IDataConnector<any, any>, payload: IActionPayload): any {

    // Dispatch the action
    if (connector) {
        return connector.store.dispatch(payload);
    } else {
        return PageBase.getInstance().store.dispatch(payload);
    }
}